import axios, {AxiosPromise} from "axios"
import {getEasasRestUrl} from "utils/utils";
import {QueryClient} from "react-query";

export const paramsSerializer = (params: any) => {
    return Object.keys(params)
        .map(key => {
            const value = params[key];
            if (value !== undefined) {
                if (Array.isArray(value)) {
                    // Convert array values to single value
                    return value.map((val: any) => `${key}=${encodeURIComponent(val)}`).join('&');
                } else {
                    return `${key}=${encodeURIComponent(value)}`;
                }
            }
            return '';
        })
        .filter(param => param !== '')
        .join('&');
};

export const easasAxios = axios.create({
    baseURL: getEasasRestUrl(),
    paramsSerializer:{serialize: paramsSerializer}
});

export const queryClient = new QueryClient();

export type Info = { headers?: Record<string, any>; code?: number };

export type APIResponse<T> = {data?: T, error?: Error, info?: Info};

export type APIPromise<T> = Promise<APIResponse<T>>;

export function requestPromiseTypeWrapper<T>(promise: AxiosPromise<T>, objMapperFn?: (data: Partial<T>) => T): APIPromise<T> {
    return promise.then((res) => {
        if(objMapperFn) {
            return ({data: objMapperFn(res.data)});
        } else {
            return {data: res.data};
        }
    }).catch((error: any) => {
        return {error: error.response?.data};
    })
}